import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_ENVIRONMENT, AppEnvironment } from '@gwc/core/config/environment.token';
import { Observable, of, from } from 'rxjs';


@Injectable({
	providedIn: 'root'
})
export class GwcApiConnService {

	private _baseUrl: string;

	constructor(
		private _http: HttpClient,
		@Inject(APP_ENVIRONMENT) private _env: AppEnvironment
	) {
		this._baseUrl = this._env.apiBaseUrl;
	}


	public request(method: string, endpoint: string | string[], queryParams?: { [key: string]: string} | null, body?: any): Observable<Object> {
		//create the query params
		var opts: { params?: HttpParams } = {};
		if(queryParams) {
			opts["params"] = new HttpParams({fromObject: queryParams});
		}

		if(Array.isArray(endpoint)) {
			endpoint = endpoint.join('/')
		}
		
		var req;
		switch(method) {
			case 'GET' :
				req = this._http.get(`${this._baseUrl}/${endpoint}`, opts);
				break;
			case 'POST' :
				req = this._http.post(`${this._baseUrl}/${endpoint}`, body)
				break;
			case 'PUT' : 
				req = this._http.put(`${this._baseUrl}/${endpoint}`, body)
				break;
			case 'DELETE' : 
				req = this._http.delete(`${this._baseUrl}/${endpoint}`);
				break;
			default : 
				req = of({})
				break;
		}

		return req;

	}



}
